import {
  Box,
  ListItemText,
  MenuItem,
  MenuList,
  Stack,
  Typography,
} from '@mui/material';
import { ReactElement } from 'react';
import { Link } from 'react-router-dom';

import { useDeviceType } from '@app/hooks/useBrowserHooks';

interface BottomMenuProps {
  menuItems: {
    target?: React.HTMLAttributeAnchorTarget;
    text: string;
    to: string;
  }[];
}

export function BottomMenu(prop: BottomMenuProps): ReactElement {
  const { menuItems } = prop;
  const { isDesktop } = useDeviceType();
  const currentYear = new Date().getFullYear();
  return (
    <Box sx={{ bgcolor: 'secondary.main' }}>
      <MenuList>
        <Stack
          direction={isDesktop ? 'row' : 'column'}
          justifyContent={isDesktop ? 'end' : 'start'}
        >
          {menuItems.map(({ text, to, target }, index) => (
            <Link
              key={index}
              to={to}
              style={{ color: 'inherit', textDecoration: 'none' }}
              target={target}
            >
              <MenuItem>
                <ListItemText>{text}</ListItemText>
              </MenuItem>
            </Link>
          ))}
        </Stack>
      </MenuList>
      <Typography
        variant="body2"
        color="textSecondary"
        textAlign={isDesktop ? 'right' : 'left'}
        sx={{ p: 2 }}
      >
        © {currentYear} Pro Doctors All rights reserved.
      </Typography>
    </Box>
  );
}
